module.exports = __webpack_public_path__ + "static/img/ok.da43222.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ok.png
// module id = 4/gI
// module chunks = 1